var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "main",
      {
        staticClass: "el-core _fixed",
        attrs: { "data-component": _vm.$options.name },
      },
      [
        _vm.isTestAccount ? _c("test-account-status-alert") : _vm._e(),
        _vm.showCommunication
          ? _c("app-core-header-communication", { attrs: { fixed: "" } })
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "el-core__wrapper wrapper",
            class: {
              _has_communication: _vm.showCommunication,
              "wrapper-comunication": _vm.showCommunication,
            },
          },
          [
            _c("div", { staticClass: "el-main" }, [
              _c(
                "div",
                {
                  staticClass: "el-main__navigation sidemenu-container",
                  class: {
                    _open: _vm.appMenuOpen,
                    _hasAccountStatusAlert: _vm.isTestAccount,
                  },
                  attrs: { id: "core-sidebar", "data-onboarding": "realTime" },
                },
                [
                  _c("app-core-header", {
                    staticClass: "menu-wrapper",
                    class: { _has_communication: _vm.showCommunication },
                    attrs: {
                      drawerOpen: _vm.drawerMenuOpen,
                      isOpen: _vm.appMenuOpen,
                    },
                    on: {
                      appMenuClicked: _vm.toggleAppMenu,
                      drawerMenuClicked: _vm.toggleDrawerMenu,
                      openOnboarding: _vm.openOnboarding,
                    },
                  }),
                  _c("app-sidemenu", {
                    attrs: { isOpen: _vm.appMenuOpen },
                    on: { appMenuClicked: _vm.toggleAppMenu },
                  }),
                  _c(
                    "div",
                    { staticClass: "sidemenu-footer" },
                    [_c("app-core-footer")],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex flex-col w-full" },
                [
                  _c("app-navigation-bar"),
                  _c(
                    "div",
                    {
                      staticClass:
                        "el-main__content content-wrapper !min-h-full",
                      attrs: { id: "core-main" },
                    },
                    [
                      _vm.mustShowGreeting
                        ? _c(
                            "div",
                            { staticClass: "el-section" },
                            [
                              _c("greeting", {
                                on: {
                                  close: _vm.closeGreeting,
                                  explore: _vm.openOnboarding,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.mustShowTimelineActivation
                        ? _c("dash-timeline-activation", {
                            attrs: { showGreeting: _vm.showGreeting },
                            on: { closeGreeting: _vm.closeGreeting },
                          })
                        : _vm._e(),
                      _c("app-breadcrumb"),
                      _vm.showNps
                        ? _c(
                            "section",
                            { staticClass: "el-section" },
                            [_c("nps", { on: { close: _vm.closeNps } })],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "transition",
                        { attrs: { name: _vm.transitionName, mode: "out-in" } },
                        [
                          _c(
                            "dash-platform-setup",
                            [
                              _c("help-center", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showDrawerHelpCenter,
                                    expression: "showDrawerHelpCenter",
                                  },
                                ],
                                ref: _vm.handleHelperCenterRef,
                                class: { hidden: !_vm.showDrawerHelpCenter },
                                attrs: { open: _vm.showDrawerHelpCenter },
                              }),
                              _c("fees-calculator", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showDrawerFeesCalculator,
                                    expression: "showDrawerFeesCalculator",
                                  },
                                ],
                                ref: _vm.handleFeesCalculatorRef,
                                class: {
                                  hidden: !_vm.showDrawerFeesCalculator,
                                },
                                attrs: { open: _vm.showDrawerFeesCalculator },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("AppFooter"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }